<!--
 * @Author: 仙道
 * @Date: 2022-08-20 16:08:44
 * @LastEditTime: 2022-08-25 00:58:17
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/fusion/FusionModal.vue
-->
<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <!-- <component :is="fusionView" :query="fusionQuery" ref="detailPage" v-if="visible" /> -->
    <DetailIndex :is="fusionView" :query="fusionQuery" v-if="visible" />
    <template slot="footer">
      <a-button @click="handleCancel">关闭</a-button>
      <!-- <a-button ghost type="primary" v-print="'#printContent'">打印</a-button> -->
    </template>
  </j-modal>
</template>

<script>
  import DetailIndex from './DetailIndex.vue'

  export default {
    name: 'FusionModal',
    components: {
      DetailIndex
    },

    data () {
      return {
        title: '',
        width: 1200,
        visible: false,
        disableSubmit: false,
        viewPath: {
          'FusionDevice': 'equipment/account/modules/DeviceDetail',
          'FusionManufacturers': 'fusion/components/Manufacturers',
          'FusionProcess': 'fusion/components/Process',
          'FusionPerson': 'fusion/components/Person'
        },
        fusionView: '',
        fusionQuery: {}
      }
    },
    methods: {
      show (view = '', query = {}) {

        this.fusionQuery = { ...query }
        this.fusionView = (resolve) => require([`@/views/${this.viewPath[view]}.vue`], resolve)
        this.visible = true

      },

      close () {
        this.$emit('ok');
        this.visible = false;
      },
      handleOk () {
        // this.$refs.detailPage.submitForm();
      },
      submitCallback (id = '') {
        this.$emit('ok', id);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>